import { Text, TextInput } from "react-native";

type FontScalingComponent = {
  defaultProps?: {
    allowFontScaling?: boolean;
    maxFontSizeMultiplier?: number;
  };
};

const disableFontScaling = (Component: FontScalingComponent) => {
  Component.defaultProps = {
    ...Component.defaultProps,
    allowFontScaling: false,
    maxFontSizeMultiplier: 1,
  };
};

disableFontScaling(Text as FontScalingComponent);
disableFontScaling(TextInput as FontScalingComponent);
